<div class="panel panel-default float-start card-size inside-padding shadowing">
  <div class="row">
    <div class="col-6">
      <h5 translate>{{component.reference.ref}}</h5>
    </div>
    <div *ngIf="!isDemoMode && !isCpqProject() && isAlreadyRequestedPrice()  && !isPricesDetailsHidden()" class="col-6">
      <app-price [mySEStatus]="utilService.getMySEStatusToSend(component)"  [priceLabel]="getPriceKeyLabel(component)" [price]="getPrice(component)"
                 class="float-end inlineDisplay"></app-price>
    </div>
    <div *ngIf="!isDemoMode && !isCpqProject() && !isAlreadyRequestedPrice()" class="col-6">
      <app-spinner [sizeClass]="'small'" class="float-end inlineDisplay spinner-top"></app-spinner>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
    <p class="subtitle description-text-overflow"  translate>{{component.reference.description}}</p>
    </div>
  </div>

  <div class="panel-body row" >

    <!-- CUBICLE SLD -->
    <div (click)="showModal(characteristicsTab, informationModal)" *ngIf="component.type === cubicleType" class="col-4 fig-container undo-bootstrap-padding">
      <app-sld-component-viewer *ngIf="component.type === cubicleType" [component] = "component"  [onCardsPanel]="true" [showCompleteSld]="false"></app-sld-component-viewer>
    </div>
    <!-- TRANSFORMER SLD -->
    <div (click)="showModal(characteristicsTab, informationModal)" *ngIf="component.type !== cubicleType" class="col-2 undo-bootstrap-padding">
      <img  class="img-transformer" src="./assets/sld/Transformer_v2.svg">
    </div>

    <!-- MAIN CHARACTERISTICS -->
    <div [ngClass]="{ 'col-9': component.type !== cubicleType, 'col-7': component.type === cubicleType}">
        <div>
          <div *ngFor="let characteristic of mainCharacteristics">
           <div class="characteristics-title" translate>{{characteristic.key}}<span>:</span></div>
           <div class="characteristics-value span-blue" translate>{{characteristic.value}}</div>
          </div>
        </div>
    </div>
    <!-- INFO BUTTON TO DISPLAY CARD DETAIL -->
    <span  (click)="showModal(characteristicsTab, informationModal)" class="info-pellet span-blue se-icons col-1">information_circle</span>
  </div>


  <!-- FOOTER OF CARD -->
  <div class="row">
     <div  class="col-6 col-sm-4"><app-dimensions (click)="showModal(layoutsTab, informationModal)" [dimension]="component.dimensions"></app-dimensions></div>
     <div  class="col-2 col-sm-4"><app-documents (click)="showModal(documentsTab, informationModal)" [documents]="component.documents"></app-documents></div>
     <div  class="col-3 col-sm-4 text-end">
       <button (click)="addComponentDispacher(component)" [ngClass]="{'btn btn-full-size btn-success':true, 'disabled':isItemOrdered() || isReadOnlyProject()}" type="button">
        <span class="button-text text-overflow" translate >T_ADD_SELECTION</span>
       </button>
     </div>
  </div>

</div>
